import { render, staticRenderFns } from "./OriginCom.vue?vue&type=template&id=b7c72b18&scoped=true&"
import script from "./OriginCom.vue?vue&type=script&lang=js&"
export * from "./OriginCom.vue?vue&type=script&lang=js&"
import style0 from "./OriginCom.vue?vue&type=style&index=0&id=b7c72b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c72b18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7c72b18')) {
      api.createRecord('b7c72b18', component.options)
    } else {
      api.reload('b7c72b18', component.options)
    }
    module.hot.accept("./OriginCom.vue?vue&type=template&id=b7c72b18&scoped=true&", function () {
      api.rerender('b7c72b18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/panel/OriginCom.vue"
export default component.exports